(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-footer"]) return;
  try {
    
  const syncFooterDetails = () => {
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;

    document.querySelectorAll('.site-footer__details').forEach((details) => {
      details.open = isDesktop;
    });
  };

  const initFooterNewsletter = () => {
    document.querySelectorAll('.site-footer[data-dialog-id]').forEach((footer) => {
      const formId = footer.dataset.klaviyoFormId;

      footer.querySelectorAll('[data-newsletter-trigger]').forEach((trigger) => {
        if (trigger.dataset.footerNewsletterBound === 'true') return;
        trigger.dataset.footerNewsletterBound = 'true';

        trigger.addEventListener('click', () => {
          if (formId) {
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', formId]);
          }
        });
      });
    });
  };

  syncFooterDetails();
  initFooterNewsletter();

  window.matchMedia('(min-width: 750px)').addEventListener('change', syncFooterDetails);
  document.addEventListener('shopify:section:load', () => {
    syncFooterDetails();
    initFooterNewsletter();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  /**
   * Keeps the search facets dialog open as a modeless aside on desktop, and
   * closed (ready for modal open via utilities) on mobile. Re-runs on connect
   * so section morphs after filter updates restore the aside state.
   */
  class SearchFacetsHost extends HTMLElement {
    /** @type {MediaQueryList} */
    #mq = window.matchMedia('(min-width: 750px)');

    connectedCallback() {
      this.#mq.addEventListener('change', this.#sync);
      this.#dialog?.addEventListener('cancel', this.#onCancel);
      this.#sync();
    }

    disconnectedCallback() {
      this.#mq.removeEventListener('change', this.#sync);
      this.#dialog?.removeEventListener('cancel', this.#onCancel);
    }

    get #dialog() {
      return this.querySelector('dialog');
    }

    /** @param {Event} event */
    #onCancel = (event) => {
      if (this.#mq.matches) event.preventDefault();
    };

    #sync = () => {
      const dialog = this.#dialog;
      if (!(dialog instanceof HTMLDialogElement)) return;

      if (this.#mq.matches) {
        if (dialog.open && dialog.matches(':modal')) {
          dialog.close();
        }
        if (!dialog.open) {
          dialog.show();
        }
      } else if (dialog.open && !dialog.matches(':modal')) {
        dialog.close();
      }
    };
  }

  if (!customElements.get('search-facets-host')) {
    customElements.define('search-facets-host', SearchFacetsHost);
  }

  } catch(e) { console.error(e); }
})();
})();
